import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { motionReduced, useSettingsStore } from '../state/settings.js';

// Loaded on demand so the start screens paint before the flap animation code arrives.
const SplitFlapText = lazy(() => import('./react-bits/SplitFlapText'));

const systemPrefersReduced = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** The app name as a split-flap board on the start screens; plain text when motion is reduced. */
export function AppTitle() {
  const { t } = useTranslation();
  const reduceMotion = useSettingsStore((s) => s.reduceMotion);
  const name = t('app.name');
  const words = [name, t('app.tagline')].map((phrase) => phrase.toUpperCase());
  const plain = <h1 className="join-title">{name}</h1>;
  if (motionReduced(reduceMotion, systemPrefersReduced())) return plain;
  return (
    <Suspense fallback={plain}>
      <h1 className="join-title">
        <SplitFlapText
          words={words}
          flipDuration={0.13}
          stagger={0.075}
          cycleDelay={3700}
          charset="alphanumeric"
          flipsPerChar={5}
          order="left"
          align="center"
          tileStyle="minimal"
          tileColor="#000000"
          textColor="currentColor"
          glare={0}
          depth={0.45}
          tileRadius={8}
          gap={3}
          fontSize="min(26px, calc((100cqw - 94px) / 24.5))"
          loop
          padTo={9}
          intro
        />
      </h1>
    </Suspense>
  );
}
